import { Expose } from "class-transformer";

import type { SurveyAction, SurveyInputType } from "../config/survey-input";

export enum ScreenTypeEnum {
  QUESTION = "question",
  AGGREGATED = "aggregated",
  INTERMEDIATE = "intermediate",
  END = "end",
  REDIRECT = "redirect",
  BAD_REQUISITES = "bad-requisites",
  TEXT_ONLY = "text-only",
  INFO_SCREEN = "info-screen",
}

export class SurveyStepHeader {
  @Expose()
  title: string = "";

  @Expose()
  titleVariant?: string;
}

export class GuidedMode {
  @Expose()
  description: string = "";

  @Expose()
  example?: string;
}

export class SurveyStepBodyExtra {
  @Expose()
  component: string = "";

  @Expose()
  icon?: string;

  @Expose()
  variant?: string;

  @Expose()
  description: string = "";
}

export class SurveyStepBody {
  @Expose()
  title: string = "";

  @Expose()
  guidedMode: GuidedMode | undefined;

  @Expose()
  description: string = "";

  @Expose()
  screenType: ScreenTypeEnum | undefined;

  @Expose()
  screenRef: string | undefined;

  @Expose()
  inputs: SurveyStepInput[] = [];

  @Expose()
  help?: string;

  @Expose()
  extra?: SurveyStepBodyExtra[];

  @Expose()
  excludedFields: string[] = [];

  @Expose()
  progressPercentage: number = 0;
}

export class SurveyStep {
  @Expose()
  group!: string;

  @Expose()
  header: SurveyStepHeader = new SurveyStepHeader();

  @Expose()
  body: SurveyStepBody = new SurveyStepBody();

  @Expose()
  actions: SurveyAction[] = [];

  @Expose()
  public resolvedContextId?: string;
}

export class SurveyStepInput {
  @Expose()
  type!: SurveyInputType;

  @Expose()
  name!: string;

  @Expose()
  collectionKey!: string;

  @Expose()
  value!: string | boolean | number | string[] | undefined;

  @Expose()
  minValue?: number | undefined;

  @Expose()
  maxValue?: number | undefined;

  @Expose()
  defaultValue?: string | undefined;

  @Expose()
  storeValue: boolean = true;

  @Expose()
  label?: string;

  @Expose()
  placeholder?: string;
}
